import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Umetnost",
  "description": "",
  "published": "2006-09-15T00:00:00.000Z",
  "redirect_from": ["/blog/umetnost/swizec/383"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Torej dragi pesnik`}<br parentName="p"></br>{`
`}{`na koncu te bo pobralo`}<br parentName="p"></br>{`
`}{`niÄ ne bo od tebe ostalo`}<br parentName="p"></br>{`
`}{`le kupÄek pepela`}<br parentName="p"></br>{`
`}{`in pesmi starih.`}</p>
    <p>{`Umetnost, kaj sploh je umetnost? VeÄina bi sklepala, da je to edina dolgo trajajoÄa stvar, ki jo Äloveštvo ustvari. Najstarejši znani dokazi o Äloveštvu so bili svoje Äase le navadna umetnost, obrt, s katero so se ukvarjali neznani umetniki o katerih nihÄe niÄesar ne ve. Seveda ne, bili so le navadne gorile višjega uma. Uma, ki pogine še prej kakor telo, ki ga vklenja. Ja um; prvi podleÅ¾e perverzijam navadnega Å¾ivljenja, toda v nekaterih uspe preÅ¾iveti dovolj dolgo, da se udejanji v stvari, ki ji pravimo umetnost.`}</p>
    <p>{`Kot ste nekateri mogoÄe Å¾e opazili, je bila pred polnimi petimi deli stvar imenovana strip obnovljena. Nov del, nove neumnosti privrejo iz uma blazneÅ¾ev. Ampak novic, o ne, tega pa le nihÄe ne posodobi, vse novice, stare, smrdljive naravnost crkujoÄe. Vsi poroÄajo le še o neumnostih, katere nobenega normalnega Äloveka ne zanimajo. Kje je kdo, ki se sploh še trudi ljudem prinesti Äesarkoli vredne novice? Prazne marnje in krvaveÄe blodnje, koga briga!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      